import { configureStore } from '@reduxjs/toolkit';
import woorimReducers from './woorimReducers';

const store = configureStore({
  reducer: woorimReducers,
});

export default store;
